import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
//PRE_QUALIFICATION_ACCEPT_DECLINED_URL
import { H1, P } from 'shared';
function PreQualificationAcceptDeclinedPage() {
    return (_jsx("div", { className: "declined-container", children: _jsxs("div", { className: "content", children: [_jsx(H1, { className: "first-title", children: "Credit Application" }), _jsx(P, { className: "first-subtitle", variant: "title-large", bold: true, children: "Thank you for your interest." }), _jsx(P, { bold: true, children: "We were unable to prequalify you." })] }) }));
}
export default PreQualificationAcceptDeclinedPage;
